import { LitElement, html, svg } from 'lit';

export class IconCheck24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>Hakemerke</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m5 11 5 5 8-9"></path></svg>`; }
}
if (!customElements.get('f-icon-check24', IconCheck24)) {
  customElements.define('f-icon-check24', IconCheck24);
}